var e={configService:"config-service",loggerService:"logger-service",themeService:"theme-service",metadataService:"metadata-service",accessService:"access-service"};export{e as DI_TOKENS};
